import n from "./createDomainForCookie.mjs";
import t from "./getConsentedPolicyVersion.mjs";
const c = async ({ expires: i }) => {
  const o = await Promise.resolve(window.latestPolicyVersionPromise);
  if (typeof o != "number")
    return;
  const e = t();
  (e === void 0 || e < o) && (document.cookie = `consented_policy_version=${o}; expires=${i}; domain=${n()}; path=/`);
};
export {
  c as default
};
